import { useTranslation } from "react-i18next";
import { X } from "lucide-react";
import { Modal } from "components/common/Modal";
import { Button } from "components/common/Button";
import { GridReviewHint } from "./GridReviewHint";
import { GridReviewModalContent } from "./GridReviewModalContent";
import type { GridReviewModalProps } from "./types";

export const GridReviewModal = ({
  isOpen,
  onClose,
  scopeTitle,
  isAllElementsMode,
  currentGroupLabel,
  isSelectable,
  plan,
  elements,
  onBulkDeleteElements,
  onBulkMoveElements,
  onJumpToElement,
  onScopeEmptied,
}: GridReviewModalProps) => {
  const { t } = useTranslation();

  if (!plan) {
    return null;
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="full"
      className="flex h-[90vh] flex-col p-0"
    >
      <div className="flex items-start gap-3 border-b border-gray-200 px-4 py-2 sm:px-6">
        <div className="min-w-0 flex-1">
          <div className="flex items-center gap-3">
            <h2 className="truncate text-base font-semibold text-gray-900">
              {scopeTitle}
            </h2>
            <span className="shrink-0 text-sm text-gray-500">
              {t("smartSurveyor.reviewPage.elementsCount", {
                count: elements.length,
              })}
            </span>
          </div>
          <div className="mt-1">
            <GridReviewHint isSelectable={isSelectable} />
          </div>
        </div>
        <Button size="sm" onClick={onClose} className="flex-shrink-0">
          <X size={18} />
        </Button>
      </div>
      <GridReviewModalContent
        plan={plan}
        elements={elements}
        isAllElementsMode={isAllElementsMode}
        currentGroupLabel={currentGroupLabel}
        isSelectable={isSelectable}
        onBulkDeleteElements={onBulkDeleteElements}
        onBulkMoveElements={onBulkMoveElements}
        onJumpToElement={onJumpToElement}
        onScopeEmptied={onScopeEmptied}
      />
    </Modal>
  );
};
